import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { RenderViewNetImpactLensParams } from '@upright/common/renderer/component-types/types-render-view-lenses';
import { RenderViewComponentType } from '@upright/common/renderer/types';
import { getLens } from '@upright/ui/common/upright/core/impact-lenses';
import { NetImpactLensSelectionState } from '@upright/ui/common/upright/core/impact-lenses/net-impact/selection-state';
import {
  NetImpactLensData,
  NetImpactLensOptions,
} from '@upright/ui/common/upright/core/impact-lenses/net-impact/types';
import { ImpactLens } from '@upright/ui/common/upright/core/impact-lenses/types';
import { useGetRenderViewComponentParamSetter } from '@upright/ui/views/render-view/context/component-param-setter';
import { BooleanRadioButtonControl } from '@upright/ui/views/render-view/controls/boolean-radio-button-control';
import { ChartTitle } from '@upright/ui/views/render-view/controls/chart-title';
import { ComponenControlWrap } from '@upright/ui/views/render-view/controls/shared';
import { getRenderViewItemNameMaybe } from '@upright/ui/views/render-view/utils';
import { useCallback } from 'react';

export const RenderViewNetImpactLensControls = (props: { params: RenderViewNetImpactLensParams }) => {
  const { params } = props;
  const setParams = useGetRenderViewComponentParamSetter(RenderViewComponentType.LENS_NET_IMPACT);

  const lens = getLens(ImpactLensType.UPRIGHT_NET_IMPACT) as ImpactLens<
    ImpactLensType.UPRIGHT_NET_IMPACT,
    NetImpactLensData,
    NetImpactLensOptions
  >;

  const selectionStateObject: NetImpactLensSelectionState = lens.unserializeSelectionState(params.selectionState);
  const setSelectionState = useCallback(
    function (newValue: {
      [key in keyof NetImpactLensSelectionState]: NetImpactLensSelectionState[key];
    }) {
      const newSelectionStateObject = { ...selectionStateObject, ...newValue };
      const newSelectionStateString = lens.serializeSelectionState(newSelectionStateObject);
      setParams(curr => ({ ...curr, selectionState: newSelectionStateString || '' }));
    },
    [lens, selectionStateObject, setParams],
  );

  return (
    <ComponenControlWrap>
      <ChartTitle {...{ params }} defaultTitle={getRenderViewItemNameMaybe(params)} />
      <BooleanRadioButtonControl
        texts={{ title: 'Info boxes', true: 'Show', false: 'Hide' }}
        // The boolean needed for the control is the opposite, i.e. "showInfoBoxes"
        currentValue={!selectionStateObject.hideKeyTakeawayBoxes}
        onChange={shouldShow => {
          setSelectionState({ hideKeyTakeawayBoxes: !shouldShow });
        }}
      />
      <BooleanRadioButtonControl
        texts={{ title: 'All net figures', true: 'Show', false: 'Hide' }}
        currentValue={!!selectionStateObject.showAllNetFigures}
        onChange={shouldShow => {
          setSelectionState({ showAllNetFigures: shouldShow });
        }}
      />
    </ComponenControlWrap>
  );
};
